import { Node_Type, ButtonData_Type } from 'ricos-schema';
import { Node_Type as Node_Type$1 } from 'ricos-types';
import React, { useCallback, useContext } from 'react';
import { RicosViewerContext } from 'ricos-context';
import { normalizeHref, getRelValue } from 'wix-rich-content-common';

const LINK_BUTTON_TYPE = "wix-draft-plugin-link-button";
const ACTION_BUTTON_TYPE = "wix-draft-plugin-action-button";

const ALIGN_CENTER = "center";
const DEFAULT_CONFIG = {
  alignment: ALIGN_CENTER,
  size: "small",
  width: "fit-content"
};
({
  settings: {
    [ACTION_BUTTON_TYPE]: `${Node_Type.BUTTON}.actionButtonSettings`,
    [LINK_BUTTON_TYPE]: `${Node_Type.BUTTON}.linkButtonSettings`
  },
  alignment: {
    [ACTION_BUTTON_TYPE]: `${Node_Type.BUTTON}.actionButtonAlignment`,
    [LINK_BUTTON_TYPE]: `${Node_Type.BUTTON}.linkButtonAlignment`
  }
});

var styles = {"button_container":"UtIN3","button_text":"wOE09","button_size_content":"_7T2rg"};

const ROOT = "buttonViewer";

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
const ButtonViewer = ({ onClick, helpers, settings = {}, buttonData }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v;
  const isActionButton = buttonData.type === ButtonData_Type.ACTION;
  const onClickHandler = useCallback(() => {
    var _a2;
    (_a2 = helpers == null ? void 0 : helpers.onViewerAction) == null ? void 0 : _a2.call(helpers, isActionButton ? ACTION_BUTTON_TYPE : LINK_BUTTON_TYPE, "Click", "");
    onClick == null ? void 0 : onClick();
  }, [helpers == null ? void 0 : helpers.onViewerAction]);
  const Component = isActionButton ? "div" : "a";
  const style = {
    color: (_d = (_b = (_a = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _a.colors) == null ? void 0 : _b.text) != null ? _d : (_c = settings.colors) == null ? void 0 : _c.color1,
    background: (_h = (_f = (_e = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _e.colors) == null ? void 0 : _f.background) != null ? _h : (_g = settings.colors) == null ? void 0 : _g.color8,
    borderRadius: (_j = (_i = buttonData.styles) == null ? void 0 : _i.border) == null ? void 0 : _j.radius,
    width: `min(100%, ${(_l = (_k = buttonData.containerData) == null ? void 0 : _k.width) == null ? void 0 : _l.custom}px)`,
    border: `${((_n = (_m = buttonData.styles) == null ? void 0 : _m.border) == null ? void 0 : _n.width) || 0}px solid ${(_r = (_p = (_o = buttonData == null ? void 0 : buttonData.styles) == null ? void 0 : _o.colors) == null ? void 0 : _p.border) != null ? _r : (_q = settings.colors) == null ? void 0 : _q.color8}`
  };
  return /* @__PURE__ */ React.createElement(
    Component,
    __spreadValues$1({
      className: styles.button_container,
      style,
      "data-hook": ROOT,
      onClick: onClickHandler,
      tabIndex: 0,
      role: "button",
      onKeyDown: (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onClickHandler();
        }
      }
    }, !isActionButton && {
      href: ((_s = buttonData.link) == null ? void 0 : _s.url) && normalizeHref(buttonData.link.url),
      target: ((_t = buttonData.link) == null ? void 0 : _t.target) && `_${buttonData.link.target.toLowerCase()}`,
      rel: ((_v = (_u = buttonData.link) == null ? void 0 : _u.rel) == null ? void 0 : _v.nofollow) ? getRelValue("nofollow") : void 0
    }),
    /* @__PURE__ */ React.createElement("div", { className: styles.button_text }, buttonData.text)
  );
};

const Button = ({ node, nodeIndex, NodeViewContainer }) => {
  var _a;
  const { helpers, config, onNodeClick } = useContext(RicosViewerContext);
  const settings = ((_a = node.buttonData) == null ? void 0 : _a.type) === "ACTION" ? config[ACTION_BUTTON_TYPE] : config[LINK_BUTTON_TYPE];
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { key: node.id, node, nodeIndex }, /* @__PURE__ */ React.createElement(
    ButtonViewer,
    {
      helpers,
      settings,
      buttonData: node.buttonData,
      onClick: () => onNodeClick == null ? void 0 : onNodeClick({ node })
    }
  ));
};

const nodeViewRenderers = {
  [Node_Type$1.BUTTON]: Button
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginButton = (type, config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULT_CONFIG), config),
    type,
    nodeViewRenderers
  };
};
const pluginLinkButton = (config) => {
  return pluginButton(LINK_BUTTON_TYPE, config);
};
const pluginActionButton = (config) => {
  return pluginButton(ACTION_BUTTON_TYPE, config);
};

export { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE, pluginActionButton, pluginLinkButton };
//# sourceMappingURL=viewer.js.map
